/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
    ControlcenterMelcoModelsMachineLicensePricingInfo,
    ControlcenterMelcoModelsMachineLicensePricingInfoFromJSON,
    ControlcenterMelcoModelsMachineLicensePricingInfoFromJSONTyped,
    ControlcenterMelcoModelsMachineLicensePricingInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
 */
export interface ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    email_address?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    new_license_count?: number;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    new_sub_start_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    new_subscription_code?: string | null;
    /**
     * 
     * @type {ControlcenterMelcoModelsMachineLicensePricingInfo}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    monthly?: ControlcenterMelcoModelsMachineLicensePricingInfo;
    /**
     * 
     * @type {ControlcenterMelcoModelsMachineLicensePricingInfo}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    yearly?: ControlcenterMelcoModelsMachineLicensePricingInfo;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    is_pending?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    license_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    product_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    transaction_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    subscription_code?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    subscription_start_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    renews_on?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    master_user_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    master_name?: string | null;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
}

export function ControlcenterMelcoControlCenterModelsUserMachineLicenseResponseFromJSON(json: any): ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse {
    return ControlcenterMelcoControlCenterModelsUserMachineLicenseResponseFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsUserMachineLicenseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'language': !exists(json, 'language') ? undefined : json['language'],
        'email_address': !exists(json, 'email_address') ? undefined : json['email_address'],
        'new_license_count': !exists(json, 'new_license_count') ? undefined : json['new_license_count'],
        'new_sub_start_date': !exists(json, 'new_sub_start_date') ? undefined : (json['new_sub_start_date'] === null ? null : new Date(json['new_sub_start_date'])),
        'new_subscription_code': !exists(json, 'new_subscription_code') ? undefined : json['new_subscription_code'],
        'monthly': !exists(json, 'monthly') ? undefined : ControlcenterMelcoModelsMachineLicensePricingInfoFromJSON(json['monthly']),
        'yearly': !exists(json, 'yearly') ? undefined : ControlcenterMelcoModelsMachineLicensePricingInfoFromJSON(json['yearly']),
        'is_pending': !exists(json, 'is_pending') ? undefined : json['is_pending'],
        'license_count': !exists(json, 'license_count') ? undefined : json['license_count'],
        'product_id': !exists(json, 'product_id') ? undefined : json['product_id'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'transaction_id': !exists(json, 'transaction_id') ? undefined : json['transaction_id'],
        'subscription_code': !exists(json, 'subscription_code') ? undefined : json['subscription_code'],
        'subscription_start_date': !exists(json, 'subscription_start_date') ? undefined : (json['subscription_start_date'] === null ? null : new Date(json['subscription_start_date'])),
        'renews_on': !exists(json, 'renews_on') ? undefined : (json['renews_on'] === null ? null : new Date(json['renews_on'])),
        'master_user_name': !exists(json, 'master_user_name') ? undefined : json['master_user_name'],
        'master_name': !exists(json, 'master_name') ? undefined : json['master_name'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
    };
}

export function ControlcenterMelcoControlCenterModelsUserMachineLicenseResponseToJSON(value?: ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'language': value.language,
        'email_address': value.email_address,
        'new_license_count': value.new_license_count,
        'new_sub_start_date': value.new_sub_start_date === undefined ? undefined : (value.new_sub_start_date === null ? null : value.new_sub_start_date.toISOString()),
        'new_subscription_code': value.new_subscription_code,
        'monthly': ControlcenterMelcoModelsMachineLicensePricingInfoToJSON(value.monthly),
        'yearly': ControlcenterMelcoModelsMachineLicensePricingInfoToJSON(value.yearly),
        'is_pending': value.is_pending,
        'license_count': value.license_count,
        'product_id': value.product_id,
        'product_code': value.product_code,
        'transaction_id': value.transaction_id,
        'subscription_code': value.subscription_code,
        'subscription_start_date': value.subscription_start_date === undefined ? undefined : (value.subscription_start_date === null ? null : value.subscription_start_date.toISOString()),
        'renews_on': value.renews_on === undefined ? undefined : (value.renews_on === null ? null : value.renews_on.toISOString()),
        'master_user_name': value.master_user_name,
        'master_name': value.master_name,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
    };
}


